export enum PromotionReasons {
  Promotion = 'Promotion',
  CareerPathChange = 'Career path change',
  Reassessment = 'Reassessment',
}
